<template>
  <div id="app-container" class="app-container-box">
    <div class="square-swiper-box">
      <van-swipe
        class="square-swipe"
        lazy-render
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in banner_list" :key="index">
          <img v-lazy="item.image" />
          <!-- <span>{{ item.image }}</span> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="square-list">
      <div class="square-title-box">
        <span class="square-title">打卡列表</span>
        <div class="square-rank">
          <img src="../../assets/icon_rank.png" />
          <!-- <span class="square-label" :class="{'select' : select_order_type == 1,'order_up':order_type == 2 && select_order_type == 1}"  @click="orderTypeClick(1)">按热度</span> -->
          <span
            class="square-label"
            :class="{
              select: select_order_type == 2,
              order_up: order_type == 2 && select_order_type == 2,
            }"
            @click="orderTypeClick(2)"
            >按时间</span
          >
        </div>
      </div>
      <div class="list-box">
        <van-list
          finished-text="没有更多了"
          :loading="list_loading"
          :finished="list_load_all"
          :immediate-check="false"
          @load="onLoadListen"
          v-if="list.length > 0"
        >
          <div
            class="list-item"
            v-for="item in list"
            :key="item.id"
            @click="enterItemDetail(item.record_id)"
          >
            <div class="item-header">
              <div class="header-left">
                <img class="left-img" :src="item.user_fmt.avatar" />
                <div class="left-name-box">
                  <div class="name-top">
                    <span>{{ item.user_fmt.realname }}</span>
                    -
                    <span>{{ item.user_fmt.number }}</span>
                    <!-- <img
                      class="name-label-img"
                      src="../../assets/icon_mark_sport.png"
                      v-if="item.classify_id == 1"
                    />
                    <img
                      class="name-label-img"
                      src="../../assets/icon_mark_art.png"
                      v-else
                    /> -->
                  </div>
                  <span class="name-time">{{
                    item.user_fmt.college_info.college
                  }}</span>
                </div>
              </div>
              <div class="header-right" @click.stop="startPraise(item)">
                <span class="right-text">{{ item.praise_num }}</span>
                <img class="right-img" src="../../assets/icon_fav_select.png" />
              </div>
            </div>
            <div class="item-content">
              <div class="content-imgs">
                <div
                  v-if="JSON.parse(item.images_fmt).length == 1"
                  class="one_img img_box"
                >
                  <img
                    v-for="imgPath in JSON.parse(item.images_fmt)"
                    v-lazy="`${imgPath}?width=400`"
                    :key="imgPath"
                  />
                </div>
                <div
                  v-else-if="JSON.parse(item.images_fmt).length == 2"
                  class="two_img img_box"
                >
                  <img
                    v-for="imgPath in JSON.parse(item.images_fmt)"
                    :key="`${imgPath}?width=300`"
                    v-lazy="imgPath"
                  />
                </div>
                <div v-else class="three_img img_box">
                  <img
                    v-for="(imgPath, index) in JSON.parse(item.images_fmt)"
                    :key="index"
                    v-lazy="`${imgPath}?width=200`"
                  />
                </div>
              </div>
              <div class="content-footer">
                <span class="name-time">{{ item.create_time_fmt }}</span>
                <img
                  class="name-label-img"
                  src="../../assets/icon_mark_sport.png"
                  v-if="item.classify_id == 1"
                />
                <img
                  class="name-label-img"
                  src="../../assets/icon_mark_art.png"
                  v-else
                />
              </div>
            </div>
          </div>
        </van-list>
        <van-empty description="暂无数据" v-else-if="list.length == 0 && list_loading == false" />
      </div>
    </div>
    <div class="loading-box" v-if="list_loading">
      <van-loading color="#ffffff" vertical>加载中...</van-loading>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import req from "@/js/req";
import User from "@/js/user";
import { useRouter } from "vue-router";

const banner_list = ref([]);
const list_loading = ref(false);
const list_load_all = ref(false);
const order_field = ref(2);
const order_type = ref(1);
const select_order_type = ref(2);

const list = ref([]);
const router = useRouter();

let page = 1;
let limit = 5;
let show_total = 50;

onMounted(() => {
  getBannerList();
  getShowCount();
});
// const getListImage = (s) => {
//     const last_s = s.split('/').pop().split('.').pop()
//     const substr = s.substr(0,s.length - last_s.length - 1)
//     const n_s = `${substr}_420.${last_s}`
//     return n_s
// }
const getBannerList = async () => {
  let data = await req.get(req.path.banner_list);
  banner_list.value = data;
};
const orderTypeClick = (index) => {
  if (select_order_type.value == index) {
    order_type.value = order_type.value == 1 ? 2 : 1;
    resetLoadList();
  } else {
    select_order_type.value = index;
    order_field.value = index;
    order_type.value = 1;
    resetLoadList();
  }
};
const resetLoadList = () => {
  page = 1;
  list.value = [];
  list_load_all.value = false;
  list_loading.value = false;
  getDataList();
};
const onLoadListen = () => {
  page += 1;
  getDataList();
};
const getShowCount = async () => {
  const param = {
    key: "ci_guangchang_num",
  };
  let data = await req.get(req.path.get_square_list_count, param);
  show_total = Number(data);
  getDataList();
};
const getDataList = async () => {
  list_loading.value = true;
  let param = {
    page: page,
    limit: limit,
    order_field: order_field.value,
    order_type: order_type.value,
  };
  // if(start_time_filter){
  //    param.start_time = start_time_x
  //    param.end_time = end_time_x
  // }
  let data = await req.get(req.path.get_check_list, param);
  list.value = [...list.value, ...data.list];
  list_loading.value = false;
  // start_time_filter = false
  const show_num = Math.min(data.total, show_total);
  if (list.value.length == data.total) {
    list_load_all.value = true;
  } else {
    if (list.value.length > show_num) {
      const del_num = list.value.length - show_num;
      list.value.splice(show_num, del_num);
      list_load_all.value = true;
    }
  }
};
const enterItemDetail = (cid) => {
  router.push({
    path: "/check-detail",
    query: {
      id: cid,
    },
  });
};
// const getIsPraise
const startPraise = async (item) => {
  const p = {
    record_id: item.record_id,
    ...User.getUTP(),
  };
  let data = await req.post(req.path.praise_, p);
  if (data > 0) {
    item.praise_num = data;
  }
};
</script>
<style lang="scss" scoped>
.square-swiper-box {
  height: 422px;

  .square-swipe {
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-image: url(../../assets/placeholder.jpg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}

.square-list {
  padding: 32px 16px 16px;

  .square-title-box {
    display: flex;
    justify-content: space-between;

    .square-title {
      color: var(--van-blue);
      font-weight: bold;
      font-size: 32px;
    }

    .square-rank {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: var(--c-text-color-gary-10);

      img {
        width: 40px;
      }

      .square-label {
        padding: 0 30px;
        border-right: 1px solid var(--c-line-color);

        &:last-of-type {
          border-right: none;
        }
      }

      .select {
        color: var(--van-blue);
        font-weight: bold;
        position: relative;

        &::after {
          position: absolute;
          content: "ˇ";
          font-weight: normal;
          top: 10px;
          right: 10px;
        }
      }

      .order_up {
        &::after {
          transform: rotate(180deg);
          top: -5px;
        }
      }
    }
  }

  .list-box {
    padding-bottom: var(--van-tabbar-height);

    .list-item {
      padding: 24px;
      background-color: white;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
      margin-top: 32px;
      border-radius: 8px;

      .item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .header-left {
          display: flex;

          .left-img {
            width: 80px;
            height: 80px;
            border-radius: 100%;
            object-fit: cover;
          }

          .left-name-box {
            display: flex;
            flex-direction: column;
            margin-left: 12px;

            .name-top {
              color: var(--c-text-color-black-8);
              font-size: 32px;
              font-weight: bold;
              display: flex;
              align-items: center;

              .number {
                font-weight: normal;
              }
            }

            .name-time {
              font-size: 22px;
              color: var(--c-text-color-gray-6);
              margin-top: 10px;

              .last-time-span {
                margin-left: 15px;
              }
            }
          }
        }

        .header-right {
          display: flex;
          align-items: center;
          flex-direction: row;

          .right-text {
            color: var(--c-text-color-red);
            font-size: 22px;
          }

          .right-img {
            width: 40px;
            height: 40px;
            margin-left: 12px;
          }
        }
      }

      .item-content {
        .content-line-box {
          display: flex;
          align-items: center;
          margin-top: 24px;

          .content-label {
            font-size: 28px;
            color: var(--c-text-color-gray-6);
            flex-shrink: 0;
          }

          .content-content {
            font-size: 28px;
            color: var(--c-text-color-black-8);
            padding: 0px 20px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        .content-imgs {
          margin-top: 24px;

          img {
            object-fit: cover;
            background-image: url(../../assets/placeholder.jpg);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            border-radius: 8px;
          }

          .img_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .one_img {
            img {
              width: 100%;
              height: 360px;
              object-fit: cover;
            }
          }

          .two_img {
            img {
              width: 49.5%;
              height: 250px;
            }
          }

          .three_img {
            img {
              width: 220px;
              height: 165px;
            }
          }
        }
        .content-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;
          .name-label-img {
            width: 160px;
            height: 36px;
          }
          .name-time {
            font-size: 22px;
            color: var(--c-text-color-gray-6);
          }
        }
      }
    }
  }
}
.loading-box {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
::v-deep .van-loading {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 50px;
  border-radius: 10px;
}
::v-deep .van-swipe__indicator--active {
  width: 48px;
  height: 12px;
  border-radius: 6px;
}
</style>
